import Image from "next/image";
import lockIcon from "assets/icons/lock.svg";
import { formatMoney } from "helpers/common";
import CardInfo, { CardInfoProps } from "./common/CardInfo";
import TitleCard, { TitleCardProps } from "./common/TitleCard";
import { Stack, StackProps, Box, BoxProps } from "@mui/material";
import AppButton, { AppButtonProps } from "components/v2/atoms/app-button/AppButton";
import { UseAppDialogResult } from "components/v2/organisms/app-dialog/AppDialog.hook";

export interface InstantVatSavingsCardProps {
    totalRefunds: number;
    daysSaved: number;
    totalReceived: number;
    demo?: boolean;
    dialog?: UseAppDialogResult;
}

function InstantVatSavingsCard(props: InstantVatSavingsCardProps) {
    const titleCardProps: TitleCardProps = {
        title: "Your InstantVAT savings",
        description: "See how much time you've saved with faster VAT refunds.",
        stackProps: {
            sx: {
                gap: 5,
            },
        },
    };

    const infoItems: CardInfoProps[] = [
        {
            title: "Total refunds",
            value: props.totalRefunds,
            demo: props.demo,
        },
        {
            title: "Days saved",
            value: props.daysSaved,
            demo: props.demo,
        },
        {
            title: "Total received",
            value: formatMoney(props.totalReceived, {
                minimumFractionDigits: 0,
            }),
            demo: props.demo,
        },
    ];

    const stackProps: StackProps = {
        sx: {
            gap: 3,
            flexDirection: "row",
        },
    };

    const demoFooterProps: BoxProps = {
        sx: {
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            width: "calc(100% + 32px)",
            marginTop: 2,
            marginX: -2,
            marginBottom: -3,
            backgroundColor: "#F5F5F5",
            padding: "12px 16px",
            borderRadius: "0 0 6px 6px",
        },
    };

    const activateButtonProps: AppButtonProps = {
        variant: "contained",
        sx: {
            backgroundColor: "#000000",
            color: "#FFFFFF",
            textTransform: "none",
            fontWeight: 500,
            fontSize: "14px",
            padding: "12px 16px",
            borderRadius: "6px",
            maxHeight: "32px",
            "&:hover": {
                backgroundColor: "#000000",
            },
        },
        onClick: () => {
            if (props.dialog) {
                props.dialog.open();
            } else {
                console.log("Activate InstantVAT clicked");
            }
        },
        children: (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Image
                    src={lockIcon}
                    alt="Lock"
                    width={16}
                    height={16}
                    style={{
                        maxWidth: "100%",
                        height: "auto",
                    }}
                />
                <span>Activate InstantVAT</span>
            </Box>
        ),
    };

    return (
        <TitleCard {...titleCardProps}>
            <Stack {...stackProps}>
                {infoItems.map((item, index) => (
                    <CardInfo {...item} key={index} />
                ))}
            </Stack>
            {props.demo && (
                <Box {...demoFooterProps}>
                    <AppButton {...activateButtonProps} />
                </Box>
            )}
        </TitleCard>
    );
}

export default InstantVatSavingsCard;
